import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";
import Modal from 'react-modal';
import LoadSpinner from "components/LoadSpinner";
import ReactJson from 'react-json-view';

const { DateTime } = require("luxon");

class PartnerizeCommissionData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            commissions: [],
            commissionsLoading: false,
            affiliateCommissionId: this.props.affiliateCommissionId,
            affiliateCommissionIdError: false,
            rawData: null,
            CommissionsTable: {
                title: "Affiliate commissions",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'commissionName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                        MUIDataTableBody: {
                            emptyTitle: {
                                textAlign: 'left',
                                paddingLeft: '385px',
                                paddingTop: '12px',
                                verticalAlign: 'top',
                                fontFamily: "'Urbanist', sans-serif",
                                fontSize: '16px',
                            }
                        }
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });

        if (!!(this.props.affiliateCommissionId)) {
            this.getCommissions();
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (!!(this.props.affiliateCommissionId) && prevProps.affiliateCommissionId !== this.props.affiliateCommissionId) {
            this.getCommissions();
        }
    }

    getCommissions = async () => {
        if (!(this.props.affiliateCommissionId)) {
            this.setState({ affiliateCommissionIdError: true });
        }
        console.log("in")

        let url = `/api/Merchant/GetPartnerizeCommissionRawDataById?id=` + this.props.affiliateCommissionId;

        this.setState({ commissionsLoading: true, affiliateCommissionIdError: false });

        try {
            const commissions = await getRequest(url);

            this.setState({
                commissions,
                commissionsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching commissions:", error);
            this.setState({ commissions: [], commissionsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    showModal = (e) => {
        e.preventDefault();
        this.setState({ show: !this.state.show });
    };

    hideModal = () => {
        this.setState({ show: false, rawData: null });
    }

    handleRawDataClick = (value) => {
        try {
            const parsed = JSON.parse(value);
            this.setState({ rawData: parsed }, () => {
                this.setState({ show: true });
            });
        } catch (err) {
            console.error("Failed to parse conversionItems:", err);
            // You can also optionally notify the user or set an error state here
        }
    };

        
    render() {
        const columns = [
            {
                name: "partnerizeCommissionId",
                label: "Partnerize Commission ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "conversionId",
                label: "Conversion ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "partnerizeCommissionCreatedDate",
                label: "Partnerize Commission Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "id",
                label: "Commission History ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "publisherId",
                label: "Publisher ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "campaignId",
                label: "Campaign ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "userId",
                label: "User ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "conversionTime",
                label: "Conversion Time",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "conversionReference",
                label: "Conversion Reference",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "creativeType",
                label: "Creative Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "creativeId",
                label: "Creative ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "specificCreativeId",
                label: "Specific Creative ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "customerType",
                label: "Customer Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "referrerIp",
                label: "Referrer IP",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "lastModified",
                label: "Last Modified",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "conversionType",
                label: "Conversion Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refDeviceId",
                label: "Ref Device ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refTrafficSourceId",
                label: "Ref Traffic Source ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refUserContextId",
                label: "Ref User Context ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refUserContext",
                label: "Ref User Context",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refConversionMetricId",
                label: "Ref Conversion Metric ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "campaignTitle",
                label: "Campaign Title",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "publisherName",
                label: "Publisher Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "wasDisputed",
                label: "Was Disputed",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "conversionItems",
                label: "Conversion Items",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <div
                                className="brandOrange"
                                style={{
                                    maxWidth: "300px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}
                                title={value}
                                onClick={() => { this.handleRawDataClick(value) }}
                            >
                                {value}
                            </div>
                        );
                    }
                }
            },
            {
                name: "metaData",
                label: "Meta Data",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refOriginId",
                label: "Ref Origin ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "publisherReference",
                label: "Publisher Reference",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "customerReference",
                label: "Customer Reference",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "sourceReferer",
                label: "Source Referer",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "currency",
                label: "Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "country",
                label: "Country",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refDevice",
                label: "Ref Device",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refPartnershipModel",
                label: "Ref Partnership Model",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refTrafficSource",
                label: "Ref Traffic Source",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refConversionMetric",
                label: "Ref Conversion Metric",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "refOrigin",
                label: "Ref Origin",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "conversionStatus",
                label: "Conversion Status",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "conversionValue",
                label: "Conversion Value",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "conversionPublisherCommission",
                label: "Conversion Publisher Commission",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "click",
                label: "Click",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <div
                                className="brandOrange"
                                style={{
                                    maxWidth: "300px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}
                                title={value}
                                onClick={() => { this.handleRawDataClick(value) }}
                            >
                                {value}
                            </div>
                        );
                    }
                }
            },
            {
                name: "conversionLag",
                label: "Conversion Lag",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "clickRef",
                label: "Click Ref",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "createdBy",
                label: "Created By",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "createdDate",
                label: "Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "modifiedBy",
                label: "Modified By",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "modifiedDate",
                label: "Modified Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            }
        ];


        return (
            <div>
                <Modal
                    isOpen={this.state.show}
                    style={{
                        overlay: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: 9998,
                        },
                        content: {
                            position: 'relative', // enables absolute positioning inside
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            border: '1px solid #ccc',
                            background: 'lightgray',
                            overflow: 'hidden', // prevent scrollbars on the whole modal
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '25px',
                            width: '85vw',
                            height: '85vh',
                            zIndex: 1060,
                        }
                    }}
                    onRequestClose={this.hideModal}
                >
                    {/* Close button */}
                    <button
                        onClick={this.hideModal}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '15px',
                            background: 'transparent',
                            border: 'none',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            zIndex: 2,
                        }}
                        aria-label="Close modal"
                    >
                        &times;
                    </button>

                    {/* Scrollable content wrapper */}
                    <div style={{
                        height: '100%',
                        overflowY: 'auto',
                        paddingRight: '10px',
                        marginTop: '30px'
                    }}>
                        {this.state.rawDataLoading ? (
                            <LoadSpinner />
                        ) : this.state.rawData === null ? (
                            <div style={{ fontFamily: "sans-serif", fontSize: "18px" }}>No data available</div>
                        ) : (
                            <ReactJson
                                src={this.state.rawData}
                                name={false}
                                collapsed={2}
                                displayDataTypes={false}
                                enableClipboard={true}
                                style={{ fontSize: "14px" }}
                            />
                        )}
                    </div>
                </Modal>
                <ThemeProvider theme={this.state.CommissionsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " commissions by ID" ?? "No affiliate selected"}</p>
                                <p style={{ fontSize: '16px', marginTop: "10px", color: "red", display: this.state.affiliateCommissionIdError ? "" : "none" }}>Enter an affiliate commission ID</p>
                            </div>
                        }
                        data={this.state.commissions}
                        columns={columns}
                        options={{
                            ...this.state.CommissionsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.commissionsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default PartnerizeCommissionData;
